import React, { useEffect } from "react";
import lodash from "lodash";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useQuery } from "@tanstack/react-query";
import { GetPubertyCountChart } from "../../../Api/analytics";
import { ErrorToast } from "../../../Utils/SweetAlert";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const PubertyCountsChart = () => {
    const { data: chartData, isFetching: loading, refetch } = useQuery({
        queryKey: ["get-puberty-count-chart"],
        queryFn: () => GetPubertyCountChart(),
        select: (response) => {
            const sortedData = lodash.sortBy(response?.data, 'label');
            const labels = sortedData?.map(item => item.label || "N/A") || [];
            const values = sortedData?.map(item => item.count) || [];
            return {
                labels,
                datasets: [
                    {
                        label: "Puberty Counts",
                        data: values,
                        backgroundColor: "#AD5ADC",
                    },
                ],
            };
        },
        throwOnError: (error) => {
            ErrorToast(error?.response?.data?.message || "Server Error.");
        },
    });

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: "bottom", labels: { font: { size: 14 } } },
            title: { display: false },
        },
    };

    useEffect(() => {
        refetch();
    }, [refetch]);

    return (
        <div className="card flex-fill border-card mb-3">
            <div className="card-header dashboard-chat-heading p-2">
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title text-black fw-bold fs-4 pl-2">Puberty Counts Overview</h5>
                </div>
            </div>
            <div className="card-body" style={{ height: '60vh' }}>
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <div className="spinner-border loader-theme" role="status" />
                    </div>
                ) : (
                    <Bar options={options} data={chartData} />
                )}
            </div>
        </div>
    );
};

export default PubertyCountsChart;
